{
    "locale": "tr-TR",
    "General": {
        "OrText": "Veya",
        "Title_MyHubert": "My Hubert",
        "Button_GoTo_MyHubert": "My Hubert'a Git"
    },
    "Header": {
        "ButtonText_CreateNewAccount": "Yeni hesap oluştur",
        "ButtonText_SignInToYourAccount": "Hesabınıza giriş yapın",
        "ButtonText_StartInterviewWithoutSigningUp": "Kayıt olmadan mülakata başla",
        "ButtonText_StartInterviewWithoutSigningIn": "Giriş yapmadan mülakata başla",
        "Navlink_Dashboard": "Kontrol Paneli",
        "Navlink_MyInterviews": "Mülakatlarım",
        "Navlink_LearnWithHubert": "Hubert ile Öğren",
        "Navlink_HelpCenter": "Yardım Merkezi",
        "MyProfile": "Profilim",
        "LogOut": "Çıkış Yap"
    },
    "Login": {
        "MainTitle": "Hubert mülakat sonuçlarınızı görmek ister misiniz?",
        "Subtitle": "Sonuçları görmek, geri bildirim almak, tavsiyeler okumak ve daha fazlası için giriş yapın.",
        "LoginTitle": "Hubert hesabınıza giriş yapın",
        "Label_Email": "E-posta",
        "Label_Password": "Şifre",
        "ButtonText_SignIn": "Giriş Yap",
        "ButtonText_ForgotPassword": "Şifremi unuttum?",
        "ButtonText_ContinueWithGoogle": "Google ile devam et",
        "OrSeparator": "Veya",
        "Error_Email_Required": "E-posta gereklidir.",
        "Error_Email_Invalid": "Geçerli bir e-posta girin.",
        "Error_Password_Required": "Şifre gereklidir.",
        "Error_Use_Same_Email_As_Interview": "Lütfen mülakatta kullandığınız e-posta adresini kullanın."
    },
    "Registration": {
        "MainTitle": "Hubert mülakat sonuçlarınızı görmek ister misiniz?",
        "Subtitle": "Sonuçları görmek, geri bildirim almak, tavsiyeler okumak ve daha fazlası için kayıt olun.",
        "RegistrationTitle": "Hubert Hesabı Oluştur",
        "BenefitsBox_Title": "Şunları yapabilirsiniz",
        "BenefitsBox_Point1": "Mülakat geçmişinize erişin",
        "BenefitsBox_Point2": "Mülakatlarınız hakkında geri bildirim alın",
        "BenefitsBox_Point3": "Cevapları yeni mülakatlarda tekrar kullanın",
        "BenefitsBox_Point4": "Mülakat tavsiyeleri alın",
        "BenefitsBox_Point5": "Kariyer rehberlerini okuyun",
        "BenefitsBox_Point6": "Ve çok daha fazlası",
        "Label_FirstName": "Ad",
        "Label_LastName": "Soyad",
        "Label_Email": "E-posta",
        "Label_Password": "Şifre",
        "Label_PhoneNumber": "Telefon numarası",
        "Label_TermsOfService": "Kabul ediyorum",
        "Label_TermsOfServiceLink": "Gizlilik Politikası ve Şartlar & Koşullar",
        "Placeholder_CountryCode": "Ülke kodunu seçin",
        "Placeholder_PhoneNumber": "Örn.5551234567",
        "HelpText_Password": "Şifre en az 6 karakter uzunluğunda olmalıdır.",
        "ButtonText_SignUp": "Kayıt Ol",
        "ButtonText_SignUpWithGoogle": "Google ile Kayıt Ol",
        "OrSeparator": "Veya",
        "Error_FirstName_Required": "Ad gereklidir.",
        "Error_LastName_Required": "Soyad gereklidir.",
        "Error_Email_Required": "E-posta gereklidir.",
        "Error_Email_Invalid": "Geçerli bir e-posta girin.",
        "Error_Email_Exists": "E-posta zaten alınmış.",
        "Error_Password_Required": "Şifre gereklidir.",
        "Error_Password_6_Characters": "Şifreniz en az 6 karakter uzunluğunda olmalıdır.",
        "Error_PhoneNumber_Required": "Telefon numarası gereklidir.",
        "Error_PhoneNumber_Invalid": "Telefon numarası geçerli değil.",
        "Error_PrivacyPolicyCheck_Required": "Gizlilik Politikası ve Şartlar & Koşullar kabul edilmelidir."
    },
    "RegistrationInviteEmail": {
        "Subtitle_BeforeInterviewCompleted": "Mülakata girmek için Hubert kullanım şartlarını kabul etmeniz yeterlidir. Devam etmek için kutucuğu işaretleyin.",
        "Subtitle_AfterInterviewCompleted": "Sonuçları görmek, geri bildirim almak, tavsiyeler okumak ve daha fazlası için kayıt olun.",
        "PrivacyPolicyText": "Kayıt ol tuşuna basarak şunları kabul edersiniz",
        "PrivacyPolicyLink": "Gizlilik Politikası ve Şartlar & Koşullar",
        "ButtonText_SignUp": "Kayıt Ol & Mülakata Git",
        "ButtonText_SignUpNormal": "Kayıt Ol",
        "ButtonText_SignInInstead": "Giriş yapmak için buraya tıklayın"
    },
    "LoginInviteEmail": {
        "Subtitle": "Sonuçları görmek, geri bildirim almak, tavsiyeler okumak ve daha fazlası için giriş yapın."
    },
    "AppMessages": {
        "internal-server-error": "Beklenmedik bir hata oluştu.",
        "invalid-credentials": "Geçersiz kimlik bilgileri. Lütfen tekrar deneyin.",
        "user-not-found": "Geçersiz kimlik bilgileri. Lütfen tekrar deneyin.",
        "account-not-found": "Geçersiz hesap. Lütfen tekrar deneyin.",
        "verify-email-title": "E-postanızı doğrulayın",
        "verify-email-subtitle": "Hesabınızı doğrulamak için lütfen e-postanızı kontrol edin.",
        "email-not-verified-title": "E-posta doğrulanmadı",
        "email-not-verified-subtitle": "Hesabınızı doğrulamak için lütfen e-postanızı kontrol edin.",
        "verifying-email-title": "E-posta doğrulanıyor",
        "verifying-email-subtitle": "Lütfen bekleyin...",
        "sign-in-title": "Giriş Yapılıyor",
        "sign-in-subtitle": "Lütfen bekleyin...",
        "server-error": "Bir şeyler ters gitti.",
        "hubert-user-exists": "Hesap zaten mevcut.",
        "account-exists": "Hesap zaten mevcut.",
        "email-verified": "E-postanız doğrulandı.",
        "email-is-taken": "E-posta zaten alınmış.",
        "re-enter-password": "Giriş yapmak için şifrenizi kullanın",
        "password-reset": "Şifreniz değiştirildi.",
        "re-enter-new-password": "Giriş yapmak için yeni şifrenizi kullanın",
        "invalid-invitation": "Geçersiz davetiye.",
        "invalid-code": "Geçersiz doğrulama kodu.",
        "email-already-verified": "E-posta zaten doğrulandı.",
        "email-mismatch-title": "E-posta Uyuşmazlığı",
        "email-mismatch-subtitle": "Lütfen iş başvurusu yaparken kullandığınız e-posta adresini kullanın."
    },
    "TransitionPage": {
        "loading-title": "Yükleniyor...",
        "loading-subtitle": "Verilerinizi hazırlıyoruz...",
        "logout-title": "Yükleniyor...",
        "logout-subtitle": "Çıkış yapılıyor..."
    },
    "ImpersonationPage": {
        "loading-title": "Yükleniyor...",
        "loading-subtitle": "Verilerinizi hazırlıyoruz..."
    },
    "ProcessInvitation": {
        "loading-title": "Yükleniyor...",
        "loading-subtitle": "Lütfen bekleyin, mülakatınız yükleniyor.",
        "InvitationNotFound": "Mülakatınızı bulamıyoruz.",
        "InvitationExpired": "Mülakata erişim bağlantısının süresi doldu.",
        "InvitationExpired_Description1": "Lütfen mülakatı şuradan açın",
        "InvitationExpired_Description2": "Veya işe alım uzmanınızla iletişime geçin.",
        "InvitationInvalid": "Bu davetiyenin bağlantısı geçersiz.",
        "InterviewCompleted": "Bu mülakat zaten tamamlandı."
    },
    "Common": {
        "MyInterviews": {
            "Title": "Mülakatlarım",
            "TableHead_Employer": "İşveren",
            "TableHead_Job": "İş",
            "TableHead_Status": "Durum",
            "TableHead_ApplicationDate": "Başvuru tarihi",
            "TableBody_StartInterview": "Mülakat tamamlanmadı. Başlamak veya devam etmek için buraya tıklayın.",
            "TableBody_NotScored": "Mülakat tamamlandı. Sonuçlar yakında hazır olacak.",
            "TableBody_Details": "Sonuçları ve daha fazlasını görmek için buraya tıklayın.",
            "ApplicationDate_Invited": "Davet edildi",
            "ApplicationDate_MinuteAgo": "dakika önce",
            "ApplicationDate_MinutesAgo": "dakika önce",
            "ApplicationDate_HourAgo": "saat önce",
            "ApplicationDate_HoursAgo": "saat önce",
            "ApplicationDate_DayAgo": "gün önce",
            "ApplicationDate_DaysAgo": "gün önce",
            "ButtonText_SeeAllInterviews": "Tüm mülakatları gör",
            "ButtonText_Details": "Detaylar",
            "ButtonText_StartInterview": "Mülakata git",
            "ButtonText_NotScored": "Sonuçlar bekleniyor",
            "NoInterviews_Message": "Sizin için geçmiş veya yaklaşan mülakat kaydı yok."
        },
        "LatestJobPostings": {
            "NoJobPostings": "Şu anda iş ilanı yok. Lütfen daha sonra tekrar kontrol edin."
        }
    },
    "Dashboard": {
        "MyCareer": {
            "Title": "Kariyerim",
            "Subtitle": "Değerlendirmeyi ve beklentilerinizi görmek için mülakatı seçin.",
            "MostRecentInterview": "En son mülakat",
            "ToDo": "Yapılacaklar",
            "NoOngoingInterviews_Title": "Yeni mülakat davetiniz yok.",
            "NoOngoingInterviews_Subtitle": "Yeni Hubert Mülakatları, işe alım uzmanları tarafından planlandığında burada görünecektir.",
            "NoRecentInterviews_Title": "Sizin için önceki mülakat kaydı yok.",
            "NoRecentInterviews_Subtitle": "Bir mülakata davet edildiğinizde, aşağıda görünecektir.",
            "ButtonText_StartInterview": "Mülakata git",
            "ButtonText_NotScored": "Sonuçlar bekleniyor",
            "ButtonText_Details": "Detaylar"
        },
        "LearnWithHubert": {
            "Title": "Hubert ile Öğren",
            "Subtitle": "Mülakat becerilerinizi ve iş performansınızı nasıl geliştireceğinize dair tavsiyeler alın.",
            "PickedForMe": "Son makaleler",
            "ButtonText_SeeAllArticles": "Tüm makaleleri gör"
        },
        "HubertTip": {
            "Title": "Hubert ipucu",
            "Subtitle": "Mülakatları daha hızlı tamamlayın",
            "Description": "Daha önce Hubert mülakatına girdiğiniz benzer bir rol için yeni bir işe mi başvuruyorsunuz? Önceki cevaplarınızı tekrar kullanabilir ve zaman kazanabilirsiniz.",
            "ButtonText_ReadMoreTips": "Daha fazla ipucu oku"
        },
        "NewCandidateModalPopup": {
            "Title": "Her şey hazır!",
            "DescriptionLine1": "Hesabınız artık hazır.",
            "DescriptionLine2": "Mülakatlarınızı ve profilinizi yönetin. Sonuçlarınızı görün, geri bildirim alın ve mülakatlar hakkında daha fazla bilgi edinin.",
            "ButtonText_LetsGo": "Başlayalım"
        },
        "InterviewCompletedModal": {
            "Title": "Harika iş!",
            "Subtitle": "Mülakatınızı tamamladınız.",
            "Description": "İşe alım uzmanları tüm başvuruları inceleyecek ve bir güncelleme olduğunda e-posta veya telefon yoluyla geri bildirim sağlayacaktır.",
            "ButtonText_Continue": "Devam Et"
        },
        "LatestJobPostings": {
            "Title": "Son iş ilanları",
            "Subtitle": "Hubert ortaklarından yakın zamanda yayınlanan diğer teklifleri keşfedin."
        }
    },
    "MyInterviews": {
        "MyInterviewsSection_Title": "Mülakatlarım",
        "MyInterviewsSection_Subtitle": "Değerlendirmeyi ve kariyer fırsatlarınızı görmek için mülakatı seçin.",
        "MyInterviewsSection_ToDo": "Yapılacaklar"
    },
    "Interview": {
        "ButtonText_SeeAllInterviews": "Tüm mülakatları gör",
        "InterviewNotFound_Title": "Erişim reddedildi",
        "InterviewNotFound_Description": "Hesabınızla ilişkili olmayan mülakat detaylarına erişmeye çalışıyorsunuz.",
        "ButtonText_GoToAllInterviews": "Mülakatlarıma Git",
        "InterviewDetails": {
            "Title": "Mülakat detayları",
            "ForRole": "Rol için",
            "InterviewCompletedOn": "Mülakat tamamlandı: {{date}} {{time}}"
        },
        "MyResult": {
            "Title": "Sonucum",
            "Subtitle": "Değerlendirilen eşleşme",
            "ButtonText_LearnMore": "Cevaplarınızın nasıl değerlendirildiğini görün",
            "GotPotential_Title": "Güçlü potansiyel, bir gereksinim eksik",
            "GotPotential_Description": "Cevaplarınız bu tür bir rol için güçlü bir potansiyel gösteriyor. Ancak, bu mülakata dayanarak, bu spesifik iş için gereken niteliklerden bir veya daha fazlasını karşılamıyor olabilirsiniz. Bu, işe alım uzmanının ihtiyaçlarına ve aday havuzuna bağlı olarak sonraki adımları etkileyebilir. Bir sonraki aşamaya davet edilmezseniz, bunun potansiyelinizi yansıtmadığını bilin. Genellikle bu, rolün spesifik ihtiyaçlarına tam olarak uymakla ilgilidir. Aşağıdaki fırsatları ve ipuçlarını kontrol edin.",
            "GotPotential_DescriptionSecondary": "Hubert'in değerlendirmesi tavsiye niteliğindedir. Nihai kararı işe alım uzmanı verir ve aday sayısı gibi diğer faktörler de sonucu etkileyebilir.",
            "GreatMatch_Title": "Güçlü eşleşme",
            "GreatMatch_Description": "Cevaplarınız, işe alım uzmanlarının bu rol için genellikle aradıklarıyla iyi bir şekilde örtüşüyor ve iş gereksinimlerini karşılıyorsunuz. Mükemmel iş. İşe alım uzmanı tüm adayları inceleyecek ve sonraki adımlara karar verecektir.",
            "GreatMatch_DescriptionSecondary": "Hubert'in değerlendirmesi tavsiye niteliğindedir. Nihai kararı işe alım uzmanı verir ve aday sayısı gibi diğer faktörler de sonucu etkileyebilir. Bir sonraki aşamaya davet edilmezseniz, bunun potansiyelinizi yansıtmadığını bilin. Genellikle bu, rolün spesifik ihtiyaçlarına tam olarak uymakla ilgilidir. Aşağıdaki fırsatları ve ipuçlarını kontrol edin.",
            "OkMatch_Title": "Nitelikli, daha fazla etki ekleyin",
            "OkMatch_Description": "İş gereksinimlerini karşılıyorsunuz. Öne çıkmak için cevaplarınızın, bu rol için genellikle görülenlere kıyasla biraz daha netlik ve özgüllüğe ihtiyacı olabilir. Somut bir örnek veya sonuç eklemenin puanınızı nerede artırabileceğini görmek için aşağıdaki cevaplarınızı inceleyin.",
            "OkMatch_DescriptionSecondary": "Hubert'in değerlendirmesi tavsiye niteliğindedir. Nihai kararı işe alım uzmanı verir ve aday sayısı gibi diğer faktörler de sonucu etkileyebilir.",
            "NotClearMatch_Title": "Şu an için daha fazla netlik gerekiyor",
            "NotClearMatch_Description": "Bu mülakata dayanarak, cevaplarınız işe alım uzmanının aradığıyla daha az uyumlu olabilir veya bir veya daha fazla gereksinimi karşılamıyor olabilirsiniz. Geliştirmek isterseniz, aşağıdaki sorulardan başlayın. Küçük değişiklikler, daha fazla detay ve net sonuçlar bir dahaki sefere büyük fark yaratabilir.",
            "NotClearMatch_DescriptionSecondary": "Hubert'in değerlendirmesi tavsiye niteliğindedir. Nihai kararı işe alım uzmanı verir ve aday sayısı gibi diğer faktörler de sonucu etkileyebilir."
        },
        "ScoreBox": {
            "ProfessionalExperiences": "Profesyonel deneyimler, motivasyonlar ve yetkinlikler",
            "QualifyingRequirements": "Bu spesifik iş için yeterlilik gereksinimleri",
            "NotQualified_Title": "Gelişim alanı",
            "NotQualified_Description": "Cevaplarınız, işe alım uzmanının bu rol için beklediğinden daha az spesifik veya sonuca odaklı olabilir. Somut bir örnek, yaptığınız eylemler veya net bir sonuç eklemenin cevabınızı güçlendirebileceği yerlere aşağıdan bakın.",
            "GreatResults_Title": "Güçlü cevaplar",
            "GreatResults_Description": "Cevaplarınız, bu tür bir rol için uygun olduğunuzu ve net bir şekilde iletişim kurduğunuzu gösteriyor. Geliştirilebilecek bir soru varsa, aşağıda vurgulanmış olarak göreceksiniz.",
            "MeetingRequirements_Title": "Gereksinimleri karşılıyor",
            "MeetingRequirements_Description": "Cevaplarınız, işe alım uzmanının bu iş için belirlediği yeterlilik gereksinimlerini karşıladığınızı gösteriyor. İyi bir temel.",
            "NotAllExpectationsMet_Title": "Bir veya daha fazla gereksinim eksik",
            "NotAllExpectationsMet_Description": "Cevaplarınıza dayanarak, sertifikalar, lisanslar, eğitim seviyesi veya deneyim yılı gibi bu spesifik iş için yeterlilik gereksinimlerinden bir veya daha fazlasını karşılamıyor olabilirsiniz.",
            "ButtonText_FindOutPossibleReasons": "Detayları görüntüle"
        },
        "ScriptFromInterview": {
            "Title": "Tam mülakatınızı okuyun",
            "ButtonText_SeeWholeTranscript": "Mülakatı oku",
            "ButtonText_DeleteInterview": "Mülakatı sil",
            "Loading_Title": "Yükleniyor...",
            "Loading_Subtitle": "Lütfen bekleyin, mülakat metniniz yükleniyor."
        },
        "HowToImproveAtInterviews": {
            "Title": "Mülakatlarda nasıl gelişilir",
            "Subtitle_Questions": "Cevabınızın potansiyel olarak geliştirilebileceği bazı sorular burada.",
            "Subtitle_NoQuestions": "Belirli bir cevap işaretlenmedi. Bu rol için etki yaratmanın en iyi yolları şunlardır.",
            "GreatMatch_Questions_Description": "Güçlü bir eşleşme olsanız bile, bazı cevaplar güçlendirilebilir. Eğer tespit ettiysek, bunları aşağıda bulacaksınız. Her sorudan önceki talimatları izleyin. Bir durumu tarif ederken durumu, ne yaptığınızı ve sonucu ekleyin. Çok kısa cevaplardan kaçının. Yüz yüze bir mülakatta olduğu gibi net ve somut açıklamalar hedefleyin.",
            "GreatMatch_NoQuestions_Description": "Sorularınızda iyi performans gösterdiniz. Mükemmel iş.",
            "OkMatch_Questions_Description": "Aşağıda cevabınızın geliştirilebileceği soruları bulacaksınız. Her sorudan önceki talimatları izleyin. Bir durumu tarif ederken durumu, ne yaptığınızı ve sonucu ekleyin. Çok kısa cevaplardan kaçının. Yüz yüze bir mülakatta olduğu gibi net ve somut açıklamalar hedefleyin.",
            "OkMatch_NoQuestions_Description": "Cevaplarınız sağlamdı, ancak bu rol rekabetçi olabilir. Bu, iyi cevapların bile ortalamada kalabileceği anlamına gelir.",
            "OkMatch_NoQuestions_DescriptionSecondary": "Bir dahaki sefere netlik ve etki hedefleyin. Sonuçla başlayın, gerçek bir örnek ekleyin ve genellikle 3 ila 6 cümle olacak şekilde kısa tutun. Ne yaptığınız, nasıl yaptığınız ve bu sayede nelerin değiştiği konusunda spesifik olun.",
            "GotPotential_Questions_Description": "Bu tür bir iş için güçlü bir aday gibi görünseniz bile, bazı cevaplar güçlendirilebilir. Eğer tespit ettiysek, bunları aşağıda bulacaksınız. Her sorudan önceki talimatları izleyin. Bir durumu tarif ederken durumu, ne yaptığınızı ve sonucu ekleyin. Çok kısa cevaplardan kaçının. Yüz yüze bir mülakatta olduğu gibi net ve somut açıklamalar hedefleyin.",
            "GotPotential_NoQuestions_Description": "Profesyonel yetkinlikler ve motivasyonlar konusunda büyük bir iyileştirme gerektiren herhangi bir cevap bulamadık. Bu konularda iyi cevap vermiş görünüyorsunuz.",
            "NotClearMatch_Questions_Description": "Aşağıda cevabınızın geliştirilebileceği soruları bulacaksınız. Her sorudan önceki talimatları izleyin. Bir durumu tarif ederken durumu, ne yaptığınızı ve sonucu ekleyin. Çok kısa cevaplardan kaçının. Yüz yüze bir mülakatta olduğu gibi net ve somut açıklamalar hedefleyin.",
            "NotClearMatch_NoQuestions_Description": "Tek bir 'kötü' cevap bulamadık. Daha çok bu rolün ihtiyaçlarıyla genel uyumla ilgilidir. Rekabet güçlüyse, küçük boşluklar önemli olabilir.",
            "NotClearMatch_NoQuestions_DescriptionSecondary": "Bir sonraki mülakatınız için somut olmaya odaklanın. Soru başına bir örnek seçin, eylemlerinizi açıklayın ve sonucu paylaşın. Kısa ve spesifik, genellikle uzun ve genelden iyidir.",
            "Alert_WantMoreAdvice": "Hubert mülakatında nasıl iyi performans göstereceğinize dair daha fazla tavsiye ister misiniz?",
            "AlertLink_ExploreOurGeneralAdviceArticle": "Genel tavsiye makalemizi keşfedin"
        },
        "SimilarOffers": {
            "Title": "Benzer teklifler"
        },
        "HowHubertScoresInterviews": {
            "Title": "Hubert mülakatları nasıl değerlendirir?",
            "Description": "Aşağıda Hubert'in mülakat cevaplarını nasıl değerlendirdiğine dair kısa bir açıklama bulunmaktadır. Ayrıca, Hubert mülakatından sonraki adımların nasıl göründüğünü açıklamak için İşe Alım Süreci bölümünü ekledik.",
            "Tabs_PossibleOutcomes": "Olası sonuçlar",
            "Tabs_RecruitmentProcess": "İşe alım süreci",
            "AssessedMatch_Title": "Değerlendirilen eşleşme",
            "AssessedMatch_Description": "Hubert, cevaplarınızın genel olarak işe alım uzmanlarının bu rolde aradıklarıyla nasıl örtüştüğünü değerlendirir. Rol gereksinimleriyle birlikte, aşağıdaki sonuçlardan birini göreceksiniz.",
            "AssessedMatch_DescriptionSecondary": "Hubert'in değerlendirmesi tavsiye niteliğindedir. Nihai kararı işe alım uzmanı verir ve aday sayısı gibi diğer faktörler de sonucu etkileyebilir.",
            "GreatMatch_Title": "Güçlü eşleşme",
            "GreatMatch_Description": "Cevaplarınız, işe alım uzmanlarının aradıklarıyla iyi bir şekilde örtüşüyor ve gereksinimleri karşılıyorsunuz. Mükemmel iş. İşe alım uzmanı adayları inceleyecek ve sonraki adımlara karar verecektir.",
            "GotPotential_Title": "Güçlü potansiyel, bir gereksinim eksik",
            "GotPotential_Description": "Cevaplarınız güçlü bir potansiyel gösteriyor. Ancak, bir veya daha fazla gerekli niteliği karşılamıyor olabilirsiniz. Bu, işe alım uzmanının ihtiyaçlarına bağlı olarak sonraki adımları etkileyebilir.",
            "OkMatch_Title": "Nitelikli, daha fazla etki ekleyin",
            "OkMatch_Description": "Gereksinimleri karşılıyorsunuz. Öne çıkmak için cevaplarınızın daha fazla netlik ve özgüllüğe ihtiyacı olabilir. Gelecekte örneklerinizi güçlendirmek için mülakattaki geri bildirimleri kullanın.",
            "NotClearMatch_Title": "Şu an için daha fazla netlik gerekiyor",
            "NotClearMatch_Description": "Bu mülakata dayanarak, cevaplarınız aranan kriterlerle daha az uyumlu olabilir ve bazı gereksinimleri karşılamıyor olabilirsiniz. Netlik ve örnekler ekleyebileceğiniz yerleri görmek için cevaplarınızı inceleyin.",
            "ProfessionalExperiences_Title": "Profesyonel deneyimler, motivasyonlar ve yetkinlikler",
            "ProfessionalExperiences_Description": "Bunlar önceki deneyimleriniz, iş motivasyonunuz ve rolle ilgili yetkinlikleriniz hakkındaki sorulardır. İşe alım uzmanları hangi soruların kullanılacağına karar verir.",
            "GreatResults_Title": "Güçlü cevaplar",
            "GreatResults_Description": "Cevaplarınız, bu tür bir rol için uygun olduğunuzu ve net bir şekilde iletişim kurduğunuzu gösteriyor. Geliştirilebilecek bir soru varsa vurgulanacaktır.",
            "NotQualified_Title": "Gelişim alanı",
            "NotQualified_Description": "Cevaplarınız daha az spesifik veya sonuç odaklı olabilir. Somut bir örnek veya net bir sonucun cevaplarınızı güçlendirebileceği vurgulanan yerleri arayın.",
            "QualifyingRequirements_Title": "Temel veya yeterlilik gereksinimleri",
            "QualifyingRequirements_Description": "Bunlar, işe alım uzmanının yeterlilik gereksinimleri olarak belirlediği sorulardır. Örneğin gerekli bir sertifika, ehliyet veya belirli bir deneyim seviyesi.",
            "MeetingRequirements_Title": "Gereksinimleri karşılıyor",
            "MeetingRequirements_Description": "Cevaplarınız, yeterlilik gereksinimlerini karşıladığınızı gösteriyor. İyi bir temel.",
            "NotAllExpectationsMet_Title": "Bir veya daha fazla gereksinim eksik",
            "NotAllExpectationsMet_Description": "Cevaplarınıza dayanarak, bu spesifik iş için yeterlilik gereksinimlerinden bir veya daha fazlasını karşılamıyor olabilirsiniz.",
            "RecruitmentProcess_Title": "İşe alım süreci",
            "RecruitmentProcess_Description": "Hubert, genellikle birçok adayın olduğu bir işe alım sürecinde ilk adım olarak kullanılır. Herkesin bir mülakat yapmasını ve kendisi hakkında daha fazla şey paylaşmasını sağlar. Sorular herkes için aynı olduğundan süreç daha tutarlıdır. Hubert yaş, cinsiyet veya dış görünüş gibi bilgileri kullanmaz, bu da bilinçsiz önyargı riskini azaltır.",
            "EventOne_Title": "Hubert ile mülakat yapıyorsunuz",
            "EventOne_Description": "Mülakatı size en uygun zamanda ve yerde yaparsınız. Zaman kısıtlaması yoktur ve istediğiniz zaman ara verebilirsiniz.",
            "EventTwo_Title": "Mülakatınız değerlendiriliyor",
            "EventTwo_Description": "Hubert, cevaplarınızı modern teknoloji kullanarak değerlendirir. Değerlendirme tamamlanır tamamlanmaz sonuçlar burada ve işe alım uzmanı için görünür olur.",
            "EventThree_Title": "İşe alım uzmanı adayları seçiyor",
            "EventThree_Description": "İşe alım uzmanları yeni bir sonuç olduğunda görürler. Cevaplarınızı ve Hubert'in değerlendirmesini inceleyebilirler. Tavsiye niteliğindeki değerlendirmeye ve kendi yargılarına dayanarak, bir sonraki adıma (telefon, test, son görüşme) davet edilip edilmeyeceğinize karar verirler. Diğer adaylar daha uygun görünürse, süreçte bir sonraki adıma geçmeyebilirsiniz.",
            "ButtonText_Close": "Kapat"
        }
    },
    "MyProfile": {
        "Title": "Profilim",
        "MyDetails": {
            "Title": "Detaylarım",
            "Label_FirstName": "Ad",
            "Label_LastName": "Soyad",
            "Label_Email": "E-posta",
            "Label_PhoneNumber": "Telefon numarası",
            "ButtonText_UpdateDetails": "Detayları güncelle",
            "Error_FirstName_Required": "Ad gereklidir.",
            "Error_LastName_Required": "Soyad gereklidir.",
            "Error_Email_Required": "E-posta gereklidir.",
            "Error_Email_Invalid": "Geçerli bir e-posta girin.",
            "Error_PhoneNumber_Invalid": "Telefon numarası geçerli değil.",
            "Success_Details_Updated": "Profil güncellendi."
        },
        "ChangePassword": {
            "Title": "Şifreyi değiştir",
            "Set_Password_Title": "Şifre oluştur",
            "Label_CurrentPassword": "Mevcut şifre",
            "Label_NewPassword": "Yeni şifre",
            "Label_RepeatNewPassword": "Yeni şifreyi tekrarla",
            "Alert_SignInAgain": "Şifrenizi ayarlamak için lütfen tekrar giriş yapın.",
            "ButtonText_UpdatePassword": "Şifreyi güncelle",
            "ButtonText_SetPassword": "Şifreyi ayarla",
            "ButtonText_SignInAgain": "Tekrar giriş yap",
            "Error_CurrentPassword_Required": "Mevcut şifre gereklidir.",
            "Error_CurrentPassword_DoesntMatch": "Şifre mevcut şifreyle eşleşmiyor.",
            "Error_NewPassword_Required": "Yeni şifre gereklidir.",
            "Error_NewPassword_6_Characters": "Yeni şifreniz en az 6 karakter uzunluğunda olmalıdır.",
            "Error_RepeatNewPassword_Required": "Yeni şifre tekrarı gereklidir.",
            "Error_RepeatNewPassword_DoesntMatch": "Şifre yeni şifreyle eşleşmiyor.",
            "Success_Password_Changed": "Şifre güncellendi.",
            "Error_Invalid_CurrentPassword": "Geçersiz mevcut şifre."
        },
        "NotificationPreferences": {
            "Title": "Bildirim tercihleri",
            "Label_ReceiveUpdatesToggle": "Hubert güncellemelerini almak istiyorum.",
            "Label_ReceiveUpdatesToggleHelpText": "Kariyer rehberleri, mülakat ipuçları ve daha fazlasını alacaksınız."
        },
        "AccountRemoval": {
            "Title": "Hesap silme",
            "ButtonText_RemoveMyAccount": "Hesabımı sil"
        }
    },
    "PreInterviewPage": {
        "Title_Hello": "Merhaba",
        "Subtitle": "İş görüşmenize başlamak üzeresiniz.",
        "TipBox_Title": "Başarılı olmanıza yardımcı olacak birkaç ipucu.",
        "TipBox_Tip1": "Mülakatı odaklanabileceğiniz sakin bir yerde yapın.",
        "TipBox_Tip2": "Bilgisayar ve klavye kullanın (mobil cihazda yazmaya çok alışkın değilseniz).",
        "TipBox_Tip3": "Cevaplarınızda olabildiğince spesifik ve detaylı olun. Sizi iyi tanımak istiyoruz.",
        "TipBox_Tip4": "İhtiyacınız olan zamanı ayırın. Süre sınırı yoktur.",
        "TipBox_Tip5": "İstediğiniz zaman ara verip kaldığınız yerden devam edebilirsiniz.",
        "TipBox_Tip6": "Kendiniz olun ve gerçek bir mülakat ciddiyetiyle yaklaşın.",
        "CheckAdviceArticle_Text1": "Mülakatta başarılı olmak için daha fazla ipucu isterseniz, bu",
        "CheckAdviceArticle_Text2": "makaleye",
        "CheckAdviceArticle_Text3": "göz atın.",
        "ReadyToGetStarted": "Başlamaya hazır mısınız?",
        "ORSeparator_Text": "Veya",
        "ButtonText_StartInterviewNow": "Mülakatı başlat",
        "ButtonText_SetReminder": "Hazır değilim, hatırlatıcı ayarla",
        "PrivacyPolicyText": "Mülakatı başlat'a basarak şunları kabul edersiniz",
        "PrivacyPolicyLink": "Gizlilik Politikası ve Şartlar & Koşullar"
    },
    "InterviewCompletedPageInviteEmail": {
        "CompletedAlert_Title": "Harika iş!",
        "CompletedAlert_Subtitle": "Mülakatınızı tamamladınız.",
        "CompletedAlert_Description": "İşe alım uzmanları başvuruları inceleyecek ve bir güncelleme olduğunda geri bildirim sağlayacaktır.",
        "InterviewNotCompleted": "Bu mülakat tamamlanmadı."
    },
    "HelpCenter": {
        "BannerSection": {
            "Title": "Yardım merkezi",
            "Subtitle": "Hubert hakkında en sık sorulan soruların cevaplarını bulun.",
            "Label_Search": "sıkça sorulan soruları ara",
            "ButtonText_Search": "Ara"
        },
        "FAQSection": {
            "Tabs_All": "Tümü",
            "Tabs_AboutHubertInterview": "Hubert mülakatı hakkında",
            "Tabs_TechnicalSupport": "Teknik destek"
        },
        "StillHaveQuestion": {
            "Title": "Hala sorunuz mu var?",
            "Description": "Yardımcı olmaktan mutluluk duyarız.",
            "DropUsAEmail": "Bize e-posta gönderin: hubert@hubert.ai"
        },
        "Q&ATexts": {
            "AboutHubertInterview": [
                {
                    "q": "Mülakatı telefonla yapabilir miyim?",
                    "a": "Hubert şu anda sadece sohbet yoluyla çalışmaktadır. Tıbbi bir engeliniz varsa lütfen şirketle iletişime geçin."
                },
                {
                    "q": "Mülakatı başka bir dilde yapabilir miyim?",
                    "a": "Bazı mülakatlarda dil seçeneği vardır. Yoksa, dil muhtemelen bir gerekliliktir. Şirkete danışın."
                },
                {
                    "q": "Kısa cevaplar verirsem cezalandırılır mıyım?",
                    "a": "Hayır, uygun şekilde cevap verdiğiniz sürece sorun yok. Ancak detaylar yardımcı olur."
                },
                {
                    "q": "Cevaplarımı tekrar kullanabilir miyim?",
                    "a": "Evet, My Hubert'e giriş yaptıysanız ve benzer bir role başvuruyorsanız mümkündür."
                },
                {
                    "q": "Mülakatımı bir insan okuyacak mı?",
                    "a": "Evet, müşterilerimizden mülakatları manuel olarak kontrol etmeleri istenir."
                },
                {
                    "q": "Mülakatı yaptım, şimdi ne olacak?",
                    "a": "Sonuçlar işe alım uzmanına gönderilir. Cevaplarınızı ve değerlendirmeyi incelerler ve sonraki adıma (telefon, test, mülakat) karar verirler."
                },
                {
                    "q": "Sürecin sonraki adımları hakkında sorum var, kiminle iletişime geçmeliyim?",
                    "a": "Lütfen başvurduğunuz şirketle iletişime geçin."
                },
                {
                    "q": "Önyargı oluşmamasını nasıl sağlıyorsunuz?",
                    "a": "Hubert tutarlıdır ve yaş, cinsiyet veya görünüş gibi bilgileri bilmez, bu da önyargıyı azaltır."
                },
                {
                    "q": "İnsan tarafından mülakat yapılabilir mi?",
                    "a": "Bunu sormak için şirketle iletişime geçin."
                },
                {
                    "q": "Hubert bir insan mı?",
                    "a": "Hayır, Hubert bir bilgisayar sistemidir."
                },
                {
                    "q": "Cevaplarımı sonradan değiştirebilir miyim?",
                    "a": "Hayır, gerçek bir mülakatta olduğu gibi değiştiremezsiniz."
                },
                {
                    "q": "Nasıl başarılı olabilirim?",
                    "a": "Soruları dikkatlice okuyun, talimatları izleyin, gerçek örnekler verin ve dürüst olun."
                },
                {
                    "q": "İşe ihtiyacım var, kiminle iletişime geçmeliyim?",
                    "a": "Başvurduğunuz şirketle iletişime geçin."
                },
                {
                    "q": "Haber alamadım. Ne yapmalıyım?",
                    "a": "İşe alım uzmanları bir sonraki adımı belirler. Diğer adaylar daha uygun görünürse süreçte bir sonraki adıma geçmeyebilirsiniz. Güncelleme için işe alım uzmanıyla iletişime geçebilirsiniz."
                },
                {
                    "q": "Deneyimim var ama işi alamadım. Neden?",
                    "a": "Rekabet yüksek olabilir. Şirketten geri bildirim isteyin veya tavsiyeler için My Hubert'i kontrol edin."
                },
                {
                    "q": "Mülakat ne kadar sürer?",
                    "a": "10 ila 25 dakika arası. Acele etmeyin."
                },
                {
                    "q": "Veri işleme hakkında nereden bilgi alabilirim?",
                    "a": "https://www.hubert.ai/candidate-privacy-policy"
                }
            ],
            "TechnicalSupport": [
                {
                    "q": "Önceki mülakatlarımı neden göremiyorum?",
                    "a": "Başvuruda ve girişte aynı e-postayı kullandığınızdan emin olun (Google girişi dahil)."
                },
                {
                    "q": "Neden e-posta almadım?",
                    "a": "Spam klasörünü kontrol edin. Veya bağlantıyı bulmak için başvuru e-postanızla bir My Hubert hesabı oluşturun."
                },
                {
                    "q": "E-postadaki bağlantıyı bulamıyorum.",
                    "a": "Spam klasörünü kontrol edin. Veya My Hubert'e giriş yapıp 'Mülakatlarım' bölümüne bakın."
                },
                {
                    "q": "Mobilde çalışıyor mu?",
                    "a": "Evet! Ancak bilgisayarda yazmak daha rahat olabilir."
                },
                {
                    "q": "Çalışmıyor, ne yapmalıyım?",
                    "a": "hubert@hubert.ai adresine e-posta gönderin."
                },
                {
                    "q": "Hesabımı silmek istiyorum, ne yapmalıyım?",
                    "a": "hubert@hubert.ai adresine e-posta gönderin."
                },
                {
                    "q": "Yarım kaldı, nasıl dönebilirim?",
                    "a": "E-postadaki bağlantıya tıklayın veya My Hubert'e giriş yapın."
                }
            ]
        }
    },
    "LearnWithHubert": {
        "BannerSection": {
            "Title": "Hubert ile Öğren",
            "Subtitle": "Şansınızı nasıl artıracağınızı ve işte nasıl daha iyi performans göstereceğinizi öğrenin.",
            "Label_Search": "rehberleri ara",
            "ButtonText_Search": "Ara"
        },
        "TabSelector": {
            "MyFeed": "Akışım",
            "InterviewGuides": "Mülakat rehberleri",
            "CareerGuides": "Kariyer rehberleri"
        },
        "NewestOnTheFeed": "En yeniler",
        "PickedForMe": "Son makaleler",
        "InterviewGuides": "Mülakat rehberleri",
        "CareerGuides": "Kariyer rehberleri"
    },
    "Article": {
        "ButtonText_BackToAllArticles": "Tüm makalelere dön"
    },
    "ForgotPassword": {
        "ResetLinkAlert_Title": "Şifrenizi sıfırlayın",
        "ResetLinkAlert_Subtitle": "Yeni bir şifre belirlemek için e-postanıza gönderilen bağlantıya tıklayın.",
        "PasswordNotSetAlert_Message": "Şifre ayarlanmadı, şununla giriş yapın: ",
        "ResetYourPassword": {
            "MainTitle": "Hubert mülakat sonuçlarınızı görmek ister misiniz?",
            "Subtitle": "Sonuçları görmek ve geri bildirim almak için giriş yapın.",
            "FormSectionTitle": "Şifrenizi sıfırlayın",
            "Label_NewPassword": "Yeni şifre",
            "Label_ConfirmNewPassword": "Yeni şifreyi onayla",
            "Error_NewPassword_Required": "Lütfen yeni bir şifre girin.",
            "Error_Password_6_Characters": "Yeni şifreniz en az 6 karakter olmalıdır.",
            "Error_ConfirmNewPassword_Required": "Yeni şifrenizi onaylamalısınız.",
            "Error_ConfirmNewPassword_NotMatch": "Şifreler eşleşmiyor.",
            "Error_MalformedResetUrl": "Geçersiz güvenlik kodu. Lütfen tekrar deneyin.",
            "Error_ResetPasswordFailed": "Sıfırlama sorunu. Lütfen tekrar deneyin.",
            "Error_WeakPassword": "Şifre en az 6 karakter içermelidir.",
            "Error_InvalidCode_Title": "İstek süresi doldu veya geçersiz.",
            "Error_InvalidCode_Subtitle": "Lütfen şifrenizi tekrar sıfırlamayı deneyin.",
            "ButtonText_SetNewPassword": "Ayarla ve giriş yap",
            "ButtonText_RememberYourPassword": "Şifrenizi hatırladınız mı?",
            "ButtonText_SignInInstead": "Giriş yap"
        }
    },
    "PageNotFound": {
        "Title": "Sayfa bulunamadı",
        "Description": "Aradığınız sayfayı bulamıyoruz.",
        "ButtonText_GoToDashboard": "Kontrol Paneline Git",
        "ButtonText_GoToLogin": "Girişe Git"
    },
    "OldInterviewRedirectionModal": {
        "DescriptionLine1": "Cevapların yeniden kullanımı bu mülakat için henüz mevcut değil. Yakında kullanıma sunulmasını bekliyoruz, ancak mülakatı şimdi yapabilirsiniz.",
        "DescriptionLine2": "Aşağıdaki butona tıklayarak mülakata devam edin.",
        "ButtonText_TakeMeToTheInterview": "Mülakata git"
    },
    "UnsubscribeFromEmails": {
        "Title": "Emin misiniz?",
        "Subtitle": "Bu iş hakkında e-posta almayı durduracaksınız:",
        "SelectTheReason": "Lütfen bir neden seçin.",
        "ReasonText1": "Başka bir iş buldum.",
        "ReasonText2": "Artık ilgilenmiyorum.",
        "ReasonText3": "Diğer",
        "ButtonText_Unsubscribe": "Abonelikten çık",
        "Placeholder_YourReason": "Nedeniniz",
        "Success_Title": "Abonelikten başarıyla çıktınız.",
        "Loading": "Yükleniyor...",
        "Error_YourReason_Required": "Lütfen nedeni girin.",
        "Error_ServerIssue": "Sunucu hatası nedeniyle başarısız oldu."
    },
    "SocialLoginCallback": {
        "ButtonText_TryAgain": "Tekrar deneyin"
    },
    "Outreach": {
        "CandidateNotFound": "Aday bulunamadı",
        "CandidateNotFoundDesc": "Aradığınız mülakat detaylarını bulamadık.",
        "InterviewEnded": "Mülakat sona erdi",
        "InterviewEndedDesc1": "Bu mülakat oturumu sona erdi veya artık mevcut değil.",
        "InterviewEndedDesc2": "Zaman ayırdığınız için teşekkür ederiz. Herhangi bir sorunuz varsa lütfen işe alım ekibiyle iletişime geçin.",
        "ReadyTitle": "Mülakatınız için hazır mısınız, {{firstName}}?",
        "InvitationDesc": "Hubert, {{companyName}} adına sizi yaklaşık 1-2 dakika sürecek olan sohbet tabanlı bir mülakata davet ediyor.",
        "Button_StartChat": "Sohbet mülakatını başlat",
        "CancelNotice": "Buradan başlamak, bu rol için planlanan aramayı iptal edecektir.",
        "PreferNotToContinue": "Devam etmemeyi mi tercih edersiniz?",
        "DeclineLabel": "Bu rolle ilgilenmiyorum. Lütfen bu pozisyon hakkında beni bir daha aramayın veya mesaj göndermeyin.",
        "Button_ConfirmAndDecline": "Onayla ve reddet",
        "Processing": "İşleniyor...",
        "Toast_DeclineSuccess": "Mülakat başarıyla reddedildi",
        "Toast_CancelVoiceInfo": "Sesli mülakat iptal edildi. Özellik yakında gelecek.",
        "Toast_CancelError": "Mülakat iptal edilemedi. Lütfen tekrar deneyin.",
        "Footer_WithdrawConsent": "Onayınızı istediğiniz zaman geri çekebilirsiniz. Daha fazlasını ",
        "Footer_PrivacyPolicySuffix": " gizlilik politikasında",
        "Footer_And": " ve ",
        "Footer_HubertPrivacyLink": "Hubert'in gizlilik politikası ve şartlar & koşullarında öğrenebilirsiniz.",
        "Chat_InterviewWith": "{{companyName}} ile mülakat",
        "Chat_StatusConnected": "Bağlandı",
        "Chat_StatusError": "Hata",
        "Chat_StatusDisconnected": "Bağlantı kesildi",
        "Chat_StatusConnecting": "Bağlanıyor...",
        "Chat_ReadyToStart": "Mülakata başlamaya hazır mısınız?",
        "Chat_ButtonStart": "Mülakatı başlat",
        "Chat_SayHello": "Konuşmayı başlatmak için merhaba deyin.",
        "Chat_EmptyState": "Mülakatı başlatmak için bir mesaj gönderin.",
        "Chat_SelectLanguage": "Dilinizi seçin",
        "Chat_Placeholder": "Mesajınızı yazın...",
        "Chat_ButtonSend": "Gönder",
        "Chat_ButtonBack": "Geri",
        "LoadingCandidateDetails": "Aday detayları yükleniyor...",
        "FetchingCandidateDetails": "Aday detayları getiriliyor...",
        "Chat_StatusReady": "Bağlantı bekleniyor...",
        "Chat_ForbiddenError": "Bu sohbet mülakatı artık mevcut değil.",
        "Chat_GeneralError": "Sohbet başlatılamadı. Lütfen daha sonra tekrar deneyin.",
        "Chat_SelectUiLanguage": "Menü dili",
        "Chat_InterviewTitle": "İş Görüşmesi"
    }
}
